import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MenuForSamsungInvoiceView from './MenuForSamsungInoiceView';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isLoggedIn: state.signin.success
  };
};

export default connect(mapStateToProps)(withRouter(MenuForSamsungInvoiceView));
